import React from "react"
import ReactCountryFlag from "react-country-flag"
import styled from "styled-components"

// see https://flagicons.lipis.dev/

const sizeToRems = {
  tiny: 0.8,
  small: 1,
  medium: 1.5,
  large: 2,
  xlarge: 3,
  xxlarge: 4
}

type TFlagSize = "tiny" | "small" | "medium" | "large" | "xlarge" | "xxlarge"

interface IFlagProps {
  /**
   * Country code, see https://flagicons.lipis.dev/ for available options. e.g. DE
   */
  countryCode: string
  /**
   * Flag size (sizes range from 0.8rem to 4rem)
   * @default "medium"
   */
  size: TFlagSize
}

const FlagWrap = styled.div`
  display: inline-flex;
  position: relative;

  > img {
    width: auto !important;
  }
`

export default function Flag({
  size = "medium",
  countryCode = ""
}: IFlagProps) {
  let fontSize = ""
  if (!Object.keys(sizeToRems).includes(size)) {
    console.warn("Flag: invalid size detected", size)
    fontSize = "1rem"
  } else {
    fontSize = `${sizeToRems[size]}rem`
  }
  const styles = {
    fontSize
  }
  if (typeof countryCode !== "string") {
    return <p>Invalid countryCode</p>
  }
  return (
    <FlagWrap>
      <ReactCountryFlag countryCode={countryCode} svg style={styles} />
    </FlagWrap>
  )
}
